module.exports = __webpack_public_path__ + "img/model_market_card5.a2c9dd00.png";